import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M17.737 4.805A10 10 0 112 13a1 1 0 112 0 8 8 0 102.55-5.86l1.16 1.15A1 1 0 017 10H3a1 1 0 01-1-1V5a1 1 0 011.7-.7l1.44 1.42a10 10 0 0112.597-.915zM12 7a1 1 0 011 1v4.59l2.7 2.7v.01a1 1 0 01-1.4 1.4l-3-3a1 1 0 01-.3-.7V8a1 1 0 011-1z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
